import { render, staticRenderFns } from "./Secondstep.vue?vue&type=template&id=21c28444&scoped=true&"
import script from "./Secondstep.vue?vue&type=script&lang=js&"
export * from "./Secondstep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c28444",
  null
  
)

export default component.exports